import React from "react";
import "./AntiCorruptionBanner.css";

/* ---------- small inline icons ---------- */

const IconPhone = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const IconWhatsapp = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.29-1.39a9.86 9.86 0 0 0 4.75 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.13h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.14.82.84-3.06-.19-.31a8.18 8.18 0 0 1-1.26-4.36c0-4.53 3.69-8.22 8.24-8.22 2.2 0 4.27.86 5.83 2.41a8.16 8.16 0 0 1 2.41 5.82c0 4.53-3.69 8.23-8.23 8.23zm4.51-6.16c-.25-.12-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.13-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.04-.38-1.99-1.22-.73-.66-1.23-1.46-1.37-1.71-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.54.12.17 1.73 2.64 4.19 3.7.59.25 1.04.4 1.4.51.59.19 1.12.16 1.54.1.47-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.23-.16-.48-.28z" />
  </svg>
);

const IconFax = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 17h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2" />
    <rect x="6" y="14" width="12" height="8" />
    <path d="M6 2h9v5H6z" />
  </svg>
);

const IconMail = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 6-10 7L2 6" />
  </svg>
);

const IconPin = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const PHONES = "+91-44-2232 1090 / 2232 1085 / 2231 0989 / 2234 2142";
const MOBILE = "94981 80936 (Whatsapp)";
const FAX = "91-44-2232 1005";
const EMAIL = "dvac@nic.in";

const AntiCorruptionBanner = () => {
  return (
    <section className="ac-section">
      <div className="ac-shell">
        <div className="ac-card">
          <div className="ac-header">
            <span className="ac-header-badge">Official notice</span>
          </div>

          <div className="ac-body">
            {/* ============ Tamil ============ */}
            <div className="ac-block">
              <h3 className="ac-title ac-title-ta">
                இலஞ்சம் வாங்குவதும், கொடுப்பதும் குற்றம்.
              </h3>
              <span className="ac-underline" aria-hidden="true" />
              <p className="ac-line ac-line-ta">
                ஊழல் குறித்த புகார்களை கீழ்க்கண்ட முகவரிக்கு அனுப்பவும்
              </p>
              <p className="ac-org ac-org-ta">
                ஊழல் தடுப்பு மற்றும் கண்காணிப்பு இயக்ககம்,
              </p>
              <div className="ac-address">
                <IconPin />
                <span className="ac-address-ta">
                  எண்.293, எம்.கே.என். தெரு, ஆலந்தூர், சென்னை - 600 016.
                </span>
              </div>
            </div>

            <div className="ac-divider" aria-hidden="true" />

            {/* ============ English ============ */}
            <div className="ac-block">
              <h3 className="ac-title">"Bribe giving and receiving is an offence"</h3>
              <span className="ac-underline" aria-hidden="true" />
              <p className="ac-line">The complaints about corruption may be sent to</p>
              <p className="ac-org">the Directorate of Vigilance and Anti-corruption,</p>
              <div className="ac-address">
                <IconPin />
                <span>No.293, MKN Road, Alandur, Chennai - 600 016</span>
              </div>
            </div>
          </div>

          {/* ============ Contact — outlined pill rows, matches site buttons ============ */}
          <div className="ac-contact">
            <div className="ac-contact-item">
              <span className="ac-icon"><IconPhone /></span>
              <span className="ac-contact-text">{PHONES}</span>
            </div>
            <div className="ac-contact-item">
              <span className="ac-icon"><IconWhatsapp /></span>
              <span className="ac-contact-text">{MOBILE}</span>
            </div>
            <div className="ac-contact-item">
              <span className="ac-icon"><IconFax /></span>
              <span className="ac-contact-text">{FAX}</span>
            </div>
            <div className="ac-contact-item">
              <span className="ac-icon"><IconMail /></span>
              <span className="ac-contact-text">
                <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AntiCorruptionBanner;